<template>
    <div class="container">
        <div v-if="loadingFiles" key="loading" class="text-center py-5">
            <b-spinner small type="grow" label="Loading..."></b-spinner> Loading files...
        </div>
        <div v-else key="fileLoaded" class="">
            <div v-for="(group) in fileGroups" :key="group.id" class="row">
                <hr class="col-12 my-3"/>
                <div class="col-12 col-md-4">
                    <h6>{{ group.related_object_title }}</h6>
                </div>
                <div class="col-12 col-md-8">
                    <BaseS3FileDownloadButtonGroup 
                        :file-data="group.files" 
                        :vertical="true" 
                        class="w-100" 
                        :bundleDownloadLocation="'below'"
                        :bundleProps="{
                            buttonSize: 'sm',
                            buttonVariant: 'subtle-primary',
                        }"
                        :buttonProps="{
                            block: true,
                            buttonVariant: 'subtle-primary',
                            hideFilesize: false,
                            showPopoverPreview: true,
                        }"
                    ></BaseS3FileDownloadButtonGroup>
                    <!-- <div v-for="file in group.files" :key="file.id" class="mb-2">
                        <BaseS3FileDownloadButton :file-data="file"></BaseS3FileDownloadButton>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
import BaseS3FileDownloadButtonGroup from '../s3_files/BaseS3FileDownloadButtonGroup.vue';
// import FileDownloadBundleButton from '../s3_files/FileDownloadBundleButton.vue';
import { FormatDateTimeLocal, FormatFileSizeHelper } from '../../js/filters-helpers';

export default {
    name: 'PortalRfxRelatedFiles',
    components: {
        BaseS3FileDownloadButtonGroup,
        // FileDownloadBundleButton,
    },
    mixins: [errorHandling],
    props: {
        rfxId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            loadingFiles: false,
            fileGroups: [],
        }
    },
    computed: {
        hasAnyFiles() {
            return Array.isArray(this.fileGroups) && this.fileGroups.length > 0;
        },
        fileCount() {
            if (!this.hasAnyFiles) return 0;
            return this.fileGroups.reduce((acc, group) => acc + (Array.isArray(group.files) ? group.files.length : 0), 0);
        },
    },
    created() {
        
    },
    mounted() {
        this.getFileGroups();
    },
    methods: {
        async getFileGroups() {
            this.loadingFiles = true;
            let resp;
            try {
                resp = await suppliosApi.rfx.get_all_rfx_related_files(this.rfxId);
                this.fileGroups = Array.isArray(resp.data) ? resp.data : [];
                this.$emit('load-complete', this.fileGroups);
                if (this.hasAnyFiles) {
                    // only if we have files, emit event with the fileGroups, and total count
                    const loadedFilesPayload = {
                        fileGroups: this.fileGroups,
                        fileCount: this.fileCount,
                    };
                    this.$emit('loaded-files', loadedFilesPayload);
                }
            } catch (error) {
                this.apiErrorHandler(error);
            }
            this.loadingFiles = false;
        },
        /// FILTERS
        formatDateTime(value) {
            return FormatDateTimeLocal(value);
        },
        formatFileSize(value) {
            return FormatFileSizeHelper(value);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>